<template lang="html">
  <div class="categoria-blog post blog">

    <intro v-if="!!ficha" :categoria="ficha.categoria.slug"></intro>

    <div class="cabecera flex column" v-if="!!ficha">
      <div class="col-40" :style="`background: url(${server + ficha.img.enlace}) center/cover no-repeat`"></div>
      <div class="color">
        <div class="titulo container flex wrap">
          <div class="container-text">
            <p class="breadcrumb" v-if="!!ficha">
              <router-link :to="`/${this.lang}/${$t('enlaces.blog')}`">{{ $t('enlaces.textos.blog') }}</router-link> /
              <router-link :to="'/' + $t('enlaces.blog_categoria') + '/' + ficha.categoria.slug">{{ ficha.categoria.nombre
              }}
              </router-link> / {{ ficha.titulo }}
            </p>
            <span class="date">{{ ficha.fecha | dateToHuman }}</span>
            <h2 class="title-post" v-html="ficha.titulo"></h2>
          </div>
        </div>
      </div>

      <div class="subtitulo container">
        <div class="container-text flex wrap">
          <h5 v-html="ficha.entradilla"></h5>
        </div>
      </div>
    </div>

    <section class="post-in pad-sec" v-if="!!ficha">
      <div>
        <div class="container">
          <article class="container-text post-content" v-if="ficha.modulos.length != 0">
            <template v-for="el in ficha.modulos">
              <div v-if="el.tipo == 'texto'" class="parrafo" v-html="el.texto"></div>
              <div class="contenedor-imagen" v-if="el.tipo == 'imagen'">
                <img :src="server + el.enlace" v-if="el.tipo == 'imagen'" class="img-full">
                <span v-html="el.pie" v-if="el.tipo == 'imagen'" class="pie"></span>
              </div>
              <h2 v-if="el.tipo == 'titulo'" class="title--sup -green-line -black" v-html="el.value"></h2>
              <iframe :src="$options.filters.urlToID(el.enlace)" v-if="el.tipo == 'video'"></iframe>
            </template>
          </article>
        </div>

        <div class="container share flex wrap justify-between" v-if="!!ficha">
          <ul class="flex likes-xl">
            <li><i class="fa fa-eye" aria-hidden="true"></i><span>{{ ficha.hints }}</span></li>
            <li><i class="fa fa-comment-o" aria-hidden="true"></i><span>{{ ficha.comentarios.length }}</span></li>
            <like :slug="ficha.slugs[lang]" :likes="ficha.likes"></like>
          </ul>
          <rrss-share :data="ficha.titulo"></rrss-share>
        </div>
        <noticias-relacionadas v-if="!!ficha" :small="true" :cat="ficha.categoria.slug" :titulo="ficha.titulo">
        </noticias-relacionadas>
        <div class="container">
          <formulario-comentarios></formulario-comentarios>
          <listado-comentarios v-if="!!ficha.comentarios" :comentarios="ficha.comentarios"></listado-comentarios>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="js">

import Intro from '@/components/view-parts/intros/blog'
import RRSS_share from '@/components/view-parts/ficha-blog/rrss-share'
import formulario_Comentarios from '@/components/view-parts/ficha-blog/formulario-comentarios'
import listado_Comentarios from '@/components/view-parts/ficha-blog/listado-comentarios'
import noticias_relacionadas from '@/components/view-parts/ficha-blog/noticias-relacionadas'
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex';
import like from '@/components/parts/like'
export default {
  name: 'ficha-blog',
  props: [],
  components: {
    'intro': Intro,
    'rrss-share': RRSS_share,
    'formulario-comentarios': formulario_Comentarios,
    'listado-comentarios': listado_Comentarios,
    'noticias-relacionadas': noticias_relacionadas,
    like
  },
  created() {
    this.getNoticia();
    document.oncontextmenu = function () { return false; }
  },
  data() {
    return {
      ficha: ''
    }
  },
  computed: {
    ...mapGetters({
      lang: 'getLanguage',
      server: 'getServer',
      getHint: 'gethint'
    }),
  },
  methods: {
    ...mapActions({
      sendHint: 'sendHint'
    }),
    getNoticia: function () {
      axios.get(`post/${this.$route.params.id}?lang=${this.lang}`).then(response => {
        this.ficha = response.data.noticia;
        document.title = this.ficha.titulo;
        document.head.querySelector("[property='og:title']").content = this.ficha.titulo;
        document.head.querySelector("[property='og:image']").content = this.server + this.ficha.img.enlace;
        document.head.querySelector("[property='og:description']").content = this.ficha.entradilla;
        document.head.querySelector("[property='og:url']").content = location.href;
        window.prerenderReady = true;
        if (!this.getHint(this.ficha.slugs[this.lang])) {
          this.sendHint(this.ficha.slugs[this.lang]).then(r => {
            this.ficha.hints = r;
          }).catch(e => {
            console.log(e);
          });
        }
      })
        .catch(error => console.log(error));
    }
  },
  watch: {
    '$route': function () {
      this.getNoticia();
    },
    'lang': function () {
      this.$router.push({ name: "blog" })
    }
  },
  filters: {
    dateToHuman: function (value) {
      let date = new Date(value);
      let dateString = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
      return dateString;
    },
    urlToID: function (value) {
      return 'https://www.youtube.com/embed/' + value.split("v=")[1];
    }
  }
}
</script>

<style scoped>
.contenedor-imagen {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contenedor-imagen img {
  margin-bottom: 5px;
  pointer-events: none;
}

.contenedor-imagen .pie {
  font-size: 12px;
  margin-bottom: 10px;
  font-style: italic;
}

iframe {
  border: none;
  width: 100%;
  height: 503px;
  margin: 30px 0;
}

.parrafo strong {
  font-family: 'Conv_Ahmet Altun - HalisGR-Book';
}

.btn {
  width: 500px;
}


@media screen and (max-width: 768px) {
  iframe {
    height: 42vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/ficha-blog.vue